import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CustomRolesAPI from '../../api/customRoles';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCustomRolesUIFlags(_state) {
    return _state.uiFlags;
  },
  getCustomRoles(_state) {
    return _state.records;
  },
};

export const actions = {
  get: async function getCustomRoles({ commit }) {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isFetching: true });
    try {
      const response = await CustomRolesAPI.get();
      commit(types.SET_CUSTOM_ROLE, response.data);
    } catch (error) {
      // Ignore error for now
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createCustomRoles({ commit }, obj) {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isCreating: true });
    try {
      const response = await CustomRolesAPI.create(obj);
      commit(types.ADD_CUSTOM_ROLE, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isCreating: false });
    }
  },
  update: async function updateCustomRoles({ commit }, obj) {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isCreating: true });
    try {
      const response = await CustomRolesAPI.update(obj.id, obj);
      commit(types.UPDATE_CUSTOM_ROLE, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isCreating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isDeleting: true });
    try {
      await CustomRolesAPI.delete(id);
      commit(types.DELETE_CUSTOM_ROLE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CUSTOM_ROLE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_CUSTOM_ROLE]: MutationHelpers.create,
  [types.SET_CUSTOM_ROLE]: MutationHelpers.set,
  [types.UPDATE_CUSTOM_ROLE]: MutationHelpers.update,
  [types.DELETE_CUSTOM_ROLE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
